import { createRoute, useParams } from "@tanstack/solid-router";
import { Show } from "solid-js";
import { sheetsRoute } from "./sheets";
import { SheetDocument } from "@/features/documents/components/sheet-document";

function SheetDocumentPage() {
  const params = useParams({ from: "/_app/sheets/$pageId" });
  // keyed: remounts editor when document changes (clean state)
  return (
    <Show when={params().pageId} keyed>
      {(pageId) => <SheetDocument pageId={pageId} />}
    </Show>
  );
}

export const sheetsDocRoute = createRoute({
  getParentRoute: () => sheetsRoute,
  path: "/$pageId",
  component: SheetDocumentPage,
});
